import React from 'react';
export const Testimonials = () => {
  return <section className="mb-12" data-id="element-298">
      <h2 className="text-2xl font-bold text-blue-900 mb-6 text-center" data-id="element-299">
        Real Results from Dr. Grant's "Underground" Patients
      </h2>
      <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-300">
        <div className="bg-blue-50 p-6 rounded-lg shadow" data-id="element-301">
          <div className="flex justify-center mb-4" data-id="element-302">
            <img src="https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80" alt="Patricia" className="rounded-full w-20 h-20 object-cover" data-id="element-303" />
          </div>
          <h3 className="font-bold text-blue-900 mb-2 text-center" data-id="element-304">
            Patricia, 47
          </h3>
          <p className="text-gray-700 italic text-sm mb-3 text-center" data-id="element-305">
            Finance Executive
          </p>
          <p className="text-gray-700 text-sm" data-id="element-306">
            "I'd spent £15,000 on treatments in two years. My aesthetician was
            baffled when my skin texture suddenly improved dramatically between
            appointments. When I told her I'd switched to silk pillowcases, she
            said, 'That explains everything. I should have told you that first.'
            Three months later, people ask if I've had work done. I just changed
            what I sleep on."
          </p>
        </div>
        <div className="bg-blue-50 p-6 rounded-lg shadow" data-id="element-307">
          <div className="flex justify-center mb-4" data-id="element-308">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rQqA22KKB7uWZzMohWqnft/AI-Generated-Image-4_%282%29.png" alt="Lisa" className="rounded-full w-20 h-20 object-cover" data-id="element-309" />
          </div>
          <h3 className="font-bold text-blue-900 mb-2 text-center" data-id="element-310">Lisa, 52</h3>
          <p className="text-gray-700 italic text-sm mb-3 text-center" data-id="element-311">
            Teacher
          </p>
          <p className="text-gray-700 text-sm" data-id="element-312">
            "The sleep wrinkles under my eyes used to take until noon to fade.
            Now they're gone when I wake up. My husband noticed that my face
            looks 'less tired' every morning. I haven't had Botox in 8 months
            and my forehead lines are actually getting softer. My dermatologist
            asked what I'd been doing differently."
          </p>
        </div>
        <div className="bg-blue-50 p-6 rounded-lg shadow" data-id="element-313">
          <div className="flex justify-center mb-4" data-id="element-314">
            <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80" alt="Michelle" className="rounded-full w-20 h-20 object-cover" data-id="element-315" />
          </div>
          <h3 className="font-bold text-blue-900 mb-2 text-center" data-id="element-316">
            Michelle, 39
          </h3>
          <p className="text-gray-700 italic text-sm mb-3 text-center" data-id="element-317">
            Marketing Director
          </p>
          <p className="text-gray-700 text-sm" data-id="element-318">
            "I was getting preventive Botox every 4 months and spending
            £200/month on night creams. Six months after switching to silk, my
            aesthetician said I could push my Botox to every 6 months. The money
            I've saved has already paid for the pillowcase 10 times over."
          </p>
        </div>
      </div>
      <div className="bg-blue-100 p-6 rounded-lg mb-8" data-id="element-319">
        <h3 className="text-xl font-bold text-blue-900 mb-4 text-center" data-id="element-320">
          The Professional Validation
        </h3>
        <p className="text-gray-700 mb-4" data-id="element-321">
          Dr. Grant isn't the only medical professional to notice:
        </p>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-322">
          <blockquote className="bg-white p-4 rounded-lg shadow-sm" data-id="element-323">
            <p className="text-gray-700 italic mb-3" data-id="element-324">
              "I started seeing patients with dramatically improved skin texture
              who hadn't had any procedures. When I investigated, the common
              factor was always silk pillowcases. Now I quietly recommend them
              to every patient, but I can't make it an official policy."
            </p>
            <p className="text-gray-800 font-semibold" data-id="element-325">
              — Dr. Michael Torres, Beverly Hills Plastic Surgeon
            </p>
          </blockquote>
          <blockquote className="bg-white p-4 rounded-lg shadow-sm" data-id="element-326">
            <p className="text-gray-700 italic mb-3" data-id="element-327">
              "A-list celebrities have been using silk pillowcases for decades.
              It's the worst-kept secret in Hollywood. When regular clients ask
              me my #1 anti-aging recommendation, I always say silk pillowcases
              first, treatments second."
            </p>
            <p className="text-gray-800 font-semibold" data-id="element-328">
              — Sarah Williams, Celebrity Aesthetician
            </p>
          </blockquote>
        </div>
      </div>
    </section>;
};